// import parse from 'html-react-parser';

import { useEffect, useState } from "react";
import { Button } from "../../../Button/Button";
import { Image } from "../../../Image/Image";
import { LightBox } from "../../../LightBox/LightBox";
import { GetThumbnail } from "../../funcs";
import './PopupMoveAtWork.scss';
import {PopupSideBarImage} from '../../PopupSidebarImage';

export const PopupMoveAtWork = (props) => {
    return <div className="c-detail-fiche__body">
        <div className="practical">
            <div className="left">
                <div className="inner">
                    <div className="bottom">
                        <PopupMoveAtWorkSideBar dictionary={props.dictionary}
                            data={props.data}
                        />
                    </div>
                </div>
            </div>
            <div className="right">
                <Button className="c-download-pdf" buttonType={"primary"} label="download" onClick={() => props.printComponentToPdf(props.data.urlSegment)} />
                <PopupMoveAtWorkBody blockListBodyContentHandler={props.blockListBodyContentHandler} data={props.data} />
            </div>
        </div>
    </div>;
}

const PopupMoveAtWorkSideBar = (props) => {
    
    const [lightboxThumbnailUrl, setLightboxThumbnailUrl] = useState("");

    useEffect(() => {
        
        (async () => {
            if (props.data.detailSideBar.inspiratieVideos.length > 0 && props.data.detailSideBar.inspiratieVideos[0].url) {
                var thumbnail = await GetThumbnail(props.data.detailSideBar.inspiratieVideos[0].url);
                setLightboxThumbnailUrl(thumbnail);
            }
        })()

    }, [JSON.stringify(props.data.detailSideBar.inspiratieVideos)]);


    return <div className="inner">
        <div className='info'>
            <div>
                <p>
                    <strong>{props.dictionary.testimony}</strong>
                </p>
                <div dangerouslySetInnerHTML={{ __html: props.data.detailSideBar.getuigenisTekst }}></div>
                {/* {parse(props.data.detailSideBar.getuigenisTekst)} */}
            </div>
            <div className="sidebarpictures">
                {props.data.detailSideBar.getuigenisFoto !== null
                    && <div className="image">
                        <PopupSideBarImage src={props.data.detailSideBar.getuigenisFoto.url} alt={props.data.detailSideBar.getuigenisFoto.alt} />
                    </div>
                }
            </div>
            <p>
                <strong>
                    {props.dictionary.getInspired}
                </strong>
            </p>
            {props.data.detailSideBar.inspiratieTekst !== null
                && <div dangerouslySetInnerHTML={{ __html: props.data.detailSideBar.inspiratieTekst }}></div>
            }
            <div className="sidebarpictures">
                {props.data.detailSideBar.inspiratieFoto !== null
                    && <div className="image">
                        <PopupSideBarImage src={props.data.detailSideBar.inspiratieFoto.url} alt={props.data.detailSideBar.inspiratieFoto.alt} />
                    </div>
                }
            </div>
            {props.data.detailSideBar.inspiratieTekst2 !== null
                && <div dangerouslySetInnerHTML={{ __html: props.data.detailSideBar.inspiratieTekst2 }}></div>
            }
        </div>
        {
            props.data.detailSideBar.inspiratieVideos != null && props.data.detailSideBar.inspiratieVideos.length > 0
            && <LightBox thumbnail={lightboxThumbnailUrl} slides={props.data.detailSideBar.inspiratieVideos} />
        }

    </div>;
}

const PopupMoveAtWorkBody = (props) => {
    return <div className="inner">
        {props.blockListBodyContentHandler(props.data.detailBody.content)}
    </div>;
}
